module.exports = function () {

    if ($('.insights-detail').length === 0) {
        return;
    }

    var channelTooltip = tippy('.insights-detail-header__channel--with-tooltip', {
        maxWidth: '100%',
        content: document.getElementById('insights-detail-header__channel__content'),
        placement: 'top-end',
        onMount: function (instance) {
            var $instance = $(instance.popper);
            $closeCTA = $instance.find('.popover__close-cta');
            $closeCTA.unbind('click');

            $closeCTA.click(function () {
                instance.hide();
            });
        }
    })[0];

    var $form = $('.insights-detail__form');

    var getHeader = function () {
        return $('.insights-detail-header');        
    }

    var getHeaderOrHero = function () {
        var $headerOrHero = getHeader();

        if (!($headerOrHero.length)) {
            var $headerOrHero = $('.hero-module');
        }
        return $headerOrHero;
    }

    var determineFormPosition = function () {        
        var topMargin = ICF.Utils.Breakpoints.IsAtLeastTablet() ? (getHeader().outerHeight(true) * -1) + 'px' : '';

        $form.css({
            'margin-top': topMargin
        });
    };

    if ($form.length) {
        determineFormPosition();

        $(window).on('resize', function () {
            determineFormPosition();
        });
        
        var elementTarget = getHeader()[0];
        var observer = new MutationObserver(function (mutations) {
            determineFormPosition();
            adjustVideoPosition();
        });

        var config = { subtree: true, childList: true };

        observer.observe(elementTarget, config);
    }

    // offset embedded video to not clash with form
    var adjustVideoPosition = function () {
        var $video = $('.insights-detail-body__video-container');
        var $form = $('.insights-detail__form.marketo-form');

        $video.css('margin-top', '0')

        if ($video.length) {
            if (ICF.Utils.Breakpoints.IsAtLeastTablet()) {
                var formBottom = $form.offset().top + $form.outerHeight() + 24;
                var videoTop = $video.offset().top;
                var height;

                var difference;
                if (formBottom > videoTop) {
                    difference = formBottom - videoTop + 32;
                    if (difference < 48) {
                        difference = 48;
                    }
                    $video.css({ 'margin-top': difference + 'px' });
                }
            }
            else {
                $video.css({ 'margin-top': '' });
            }
        }
    };

    var adjustPodcastPosition = function () {        
        var $podcast = $('.insights-detail-podcast');

        if ($podcast.length) {            
            var podcastClasses = {
                'sticky': 'insights-detail-podcast--sticky',
                'visible': 'insights-detail-podcast--visible',
                'static': 'insights-detail-podcast--static'
            };
            var $placeholder = $('.insights-detail-header__podcast-player-placeholder');
            if ($placeholder.length) {
                var $header = getHeader();
                var $mainHeader = $('.main-header');
                var headerHeight = $header.outerHeight();
                var topPosition = headerHeight - $mainHeader.outerHeight() - $podcast.outerHeight();
                var currentPagePosition = $(window).scrollTop();
                var placeholderInfo = {
                    'initClass': 'insights-detail-header__podcast-player-placeholder--initialized',
                    'offset': $placeholder.offset().top + 'px'
                };

                if (currentPagePosition > topPosition) {
                    $podcast.addClass(podcastClasses.sticky);
                    $podcast.css({ 'top': '' });
                }
                else {
                    $podcast.removeClass(podcastClasses.sticky);
                    $podcast.css({ 'top': placeholderInfo.offset });
                }

                $placeholder.addClass(placeholderInfo.initClass);
            }
            else {
                $podcast.addClass(podcastClasses.static);
            }
                        
            $podcast.addClass(podcastClasses.visible);
        }
    };

    var $headerOrHero = getHeaderOrHero();
    $headerOrHero.one('transitionend webkitTransitionEnd oTransitionEnd', function (e) {
        adjustPodcastPosition();

        $(window).resize(function () {
            adjustVideoPosition();
            requestAnimationFrame(adjustPodcastPosition);
        });

        $(window).scroll(function () {
            requestAnimationFrame(adjustPodcastPosition);
        });
    });

    $('.insights-detail-body__video-gated-text').click(function () {
        $("html, body").animate({ scrollTop: 0 }, 300);
    });

    var $submenu = $('.insights-detail-submenu');
    var submenuStickyClass = 'insights-detail-submenu--sticky';    
    var $insightsBody = $('.insights-detail-body');
    var $lastParagraph = $insightsBody.siblings('.paragraph').last();
    var $progressTarget = $lastParagraph.length ? $lastParagraph : $insightsBody;

    var calculateSubmenuPosition = function () {
        var el = getHeaderOrHero()[0];
        var offset = ICF.Utils.Breakpoints.IsTablet() ? 128 : 80;
        var elBounds = el.getBoundingClientRect();

        if (elBounds.bottom - offset > 0) {
            $submenu.removeClass(submenuStickyClass);
        }
        else {
            $submenu.addClass(submenuStickyClass);
        }
    };

    var calculateProgressBarWidth = function ($bar) {
        var headerOffset = ICF.Utils.Breakpoints.IsTablet() ? 128 : 80;
        var heroEl = getHeaderOrHero()[0];
        var heroHeight = heroEl.getBoundingClientRect().height;
        var contentEl = $progressTarget[0];
        var contentBounds = contentEl.getBoundingClientRect();
        var submenuOffset = $submenu.outerHeight();
        var startingPoint = heroHeight - headerOffset;
        var totalOffset = headerOffset + submenuOffset;
        var adjustedBottom = contentBounds.bottom - totalOffset;

        if (document.documentElement.scrollTop < startingPoint) {
            ICF.Utils.ProgressBar.FillBar($bar, '0%');
            return;
        }

        if (adjustedBottom < 0) {
            ICF.Utils.ProgressBar.FillBar($bar, '100%');
            return;
        }

        var adjustedScrollDistance = document.documentElement.scrollTop - heroHeight;
        var ratio = adjustedScrollDistance / (adjustedScrollDistance + adjustedBottom);
        var percentage = ratio * 100 + '%';

        ICF.Utils.ProgressBar.FillBar($bar, percentage);
    };

    if ($submenu.length) {
        var $progressBar = $submenu.find('.progress-bar');
        $('.insights-detail-submenu__scroll-to-top').click(function (e) {
            e.preventDefault();

            $('html, body').animate({ scrollTop: 0 });
        });

        calculateSubmenuPosition();
        calculateProgressBarWidth($progressBar);

        $(window).scroll(function () {
            requestAnimationFrame(function () {
                calculateSubmenuPosition();
                calculateProgressBarWidth($progressBar);
            });
        });

        $(window).resize(function () {
            requestAnimationFrame(function () {
                calculateSubmenuPosition();
                calculateProgressBarWidth($progressBar);
            });
        });

        $('.main-header').addClass('header--with-submenu');
    }
};